module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        _vm.$emit('onChooseProject', _vm.project.id)
      }
    }
  }, [_c('div', {
    staticClass: "pull-left"
  }, [_c('img', {
    staticClass: "img-circle",
    attrs: {
      "src": '/image/Project/' + _vm.project.imageUrl + '?' + Date.now(),
      "alt": "User Image"
    }
  })]), _vm._v(" "), _c('h4', [_c('span', [_vm._v(_vm._s(_vm.project.name))])]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.project.city))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2df4f9bb"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/ProjectItem.vue
// module id = 757
// module chunks = 1